export const LoginInfo = {
  title: '开放平台登录'
}

export const RegisterInfo = {
  title: '欢迎注册开放平台'
}
